import React from 'react';

export default class Clinicians extends React.Component {
  render() {
    return <div className="content">
      <h3 className="title is-3">Clinicians</h3>
      <h3 className="subtitle">Authentication</h3>
      <p>This section covers additional authentication criteria for clinician users</p>

      <p>Client credential authentication includes the following extra properties when the authorized application has a clinician owner:</p>

      <h3 className="subtitle">Extra Response Parameters</h3>
      <table className="table">
        <thead>
          <th>Property</th>
          <th>Description</th>
        </thead>
        <tbody>
          <tr>
            <td>active</td>
            <td>This is a boolean value that indicates if the clinician account is still in use or not</td>
          </tr>
          <tr>
            <td>clinician_id</td>
            <td>A unique internal identifier for the clinician user</td>
          </tr>
          <tr>
            <td>site_id</td>
            <td>An external study specific identifier</td>
          </tr>
          <tr>
            <td>cci_site_id</td>
            <td>An internal study specific identifier</td>
          </tr>
          <tr>
            <td>email</td>
            <td>The email address on file for the clinician</td>
          </tr>
          <tr>
            <td>patients</td>
            <td>An array of patient objects that are available to the clinician</td>
          </tr>
        </tbody>
      </table>

      <h3 className="subtitle">Sample patient structure</h3>
      <div className="code-snippet">
<pre><code>
{`{
  "patient_id": "123456789",
  "first_name": "Test",
  "last_name": "Testerson"
}`}
</code></pre>
      </div>
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/api/Clinicians.js